import React, { Component } from 'react'
import { observer } from 'mobx-react'

@observer
class AuthLoading extends Component {
  render() {
    const { auth, children } = this.props
    return auth.loaded ? children : <div className="loading">Loading...</div>
  }
}

export default AuthLoading



// WEBPACK FOOTER //
// client/components/AuthLoading.js